import { render } from "./Payment.vue?vue&type=template&id=6b4127b5&ts=true"
import script from "./Payment.vue?vue&type=script&lang=ts"
export * from "./Payment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__